/**
 * Button variant and size constants for the Syncfusion-based Button component.
 *
 * Variants map to Syncfusion cssClass values and/or inline style overrides.
 * Sizes map to Syncfusion size classes and Tailwind utility overrides.
 */

export const BUTTON_VARIANTS = {
  PRIMARY: "primary",
  DANGER: "danger",
  WARNING: "warning",
  SUCCESS: "success",
  DEFAULT: "default",
  OUTLINE: "outline",
};

export const BUTTON_SIZES = {
  SM: "sm",
  MD: "md",
  LG: "lg",
};

/**
 * Maps each variant to its Syncfusion `cssClass` string and optional inline
 * `style` overrides. The primary variant uses the CSS custom property
 * `--primary-color` (#4f47e6) so it stays in sync with the global theme.
 */
export const VARIANT_CONFIG = {
  [BUTTON_VARIANTS.PRIMARY]: {
    cssClass: "e-primary",
    style: {
      backgroundColor: "var(--primary-color, #4f47e6)",
      borderColor: "var(--primary-color, #4f47e6)",
      color: "#fff",
    },
  },
  [BUTTON_VARIANTS.DANGER]: {
    cssClass: "e-danger",
    style: {},
  },
  [BUTTON_VARIANTS.WARNING]: {
    cssClass: "e-warning",
    style: {
      backgroundColor: "#d97706",
      borderColor: "#d97706",
      color: "#fff",
    },
  },
  [BUTTON_VARIANTS.SUCCESS]: {
    cssClass: "e-success",
    style: {},
  },
  [BUTTON_VARIANTS.DEFAULT]: {
    cssClass: "",
    style: {},
  },
  [BUTTON_VARIANTS.OUTLINE]: {
    cssClass: "e-outline",
    style: {},
  },
};

/**
 * Maps each size to its Syncfusion `cssClass` fragment.
 */
export const SIZE_CONFIG = {
  [BUTTON_SIZES.SM]: {
    cssClass: "e-small",
  },
  [BUTTON_SIZES.MD]: {
    cssClass: "",
    style: {
      padding: "0.5rem 1.25rem",
      fontSize: "0.875rem",
    },
  },
  [BUTTON_SIZES.LG]: {
    cssClass: "",
    style: {
      padding: "0.625rem 1.5rem",
      fontSize: "1rem",
    },
  },
};

